var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeOfDayEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Time Of Day Events",
    role: "img",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Time Of Day Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.053-2.947c-27.6142,0-50,22.3858-50,50s22.3858,50,50,50s50-22.3858,50-50l0,0 C97.0226,19.4514,74.6546-2.9166,47.053-2.947z M68.0129,68.0074c-1.2205,1.2191-3.1979,1.2191-4.4184,0L44.8438,49.2567 c-0.5869-0.5854-0.9168-1.3803-0.9168-2.2092V18.9242c0-1.7265,1.3996-3.126,3.126-3.126s3.126,1.3996,3.126,3.126v26.8309 L68.0129,63.589c1.2176,1.222,1.2152,3.1994-0.0055,4.4184H68.0129z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOfDayEvents);
export default __webpack_public_path__ + "static/media/time-of-day-events.d5972f79284264333f998aa711d4c1de.svg";
export { ForwardRef as ReactComponent };